/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { useEffect } from "react"
import { MasterLayout } from "components/views/atoms/layouts/MasterLayout"
import TwoColumnRightPrimary from "components/views/atoms/layouts/TwoColumnRightPrimary"
import { GuidanceElement } from "../../lib/contentful/components/GuidanceElement"
import { talkToCarrotSource } from "../../components/talk-to-carrot/send-message/SendMessageUtil"
import { SendMessage } from "../../components/talk-to-carrot/send-message/SendMessage"
import { TalkToCarrotLegal } from "../../components/talk-to-carrot/TalkToCarrotLegal"
import BreadcrumbsHeader from "components/views/atoms/BreadcrumbsHeader"
import Breadcrumb from "components/views/atoms/Breadcrumb"
import { useCurrentUser } from "components/context/user/UserContext"
import { useHistory } from "react-router-dom"
import { Title } from "services/page-title/Title"
import { goToHelpCenterLegacy } from "carrot-api/HelpCenterClient"
import { useIntl } from "react-intl"
import { useSendMessageTranslator } from "components/talk-to-carrot/send-message/useSendMessageTranslator"
import { IPageGuidance } from "contentful-types"

export function SendMessagePage(): JSX.Element {
  const { isInAppLockdown } = useCurrentUser()
  const history = useHistory()
  const intl = useIntl()
  const titleMessage = intl.formatMessage({
    defaultMessage: "Send a message"
  })
  const helpBreadcrumbTitle = intl.formatMessage({
    defaultMessage: "Help center"
  })
  const messageBreadcrumbTitle = intl.formatMessage({
    defaultMessage: "Send a message"
  })
  useEffect(() => {
    if (isInAppLockdown) {
      history.push("/get-help")
    }
  }, [history, isInAppLockdown])

  const translator = useSendMessageTranslator()
  const { heading: title, description } = translator.getTranslationsForTopic("send-a-message-page-as-string")
  const guidance = <GuidanceElement guidance={({ fields: { title, description } } as unknown) as IPageGuidance} />

  return (
    <>
      <Title title={titleMessage} />
      <MasterLayout
        header={
          <BreadcrumbsHeader
            breadcrumbs={[
              <Breadcrumb key="help-center" title={helpBreadcrumbTitle} onClick={() => goToHelpCenterLegacy()} />,
              <Breadcrumb
                key="send-a-message"
                title={messageBreadcrumbTitle}
                isActive
                onClick={() => {
                  /* Do nothing */
                }}
              />
            ]}
          />
        }
        footer={<TalkToCarrotLegal />}
      >
        <TwoColumnRightPrimary
          secondaryContent={guidance}
          primaryContent={<SendMessage source={talkToCarrotSource.SEND_A_MESSAGE_PAGE} />}
        />
      </MasterLayout>
    </>
  )
}
